import React from 'react';
import { ClockIcon } from './Icons';
export const UrgencyBlock = () => {
  return <section className="w-full bg-white py-4 md:py-6 px-4 md:px-6" data-id="element-233">
      <div className="max-w-[700px] mx-auto bg-light border-[2px] border-accent rounded-[16px] p-6 md:p-8 flex flex-col items-center" data-id="element-234">
        <ClockIcon color="#957DAD" size={32} className="mb-4" data-id="element-235" />

        <h3 className="font-playfair text-[24px] md:text-[28px] text-primary text-center mb-4" data-id="element-236">
          Launch Price — Limited Time
        </h3>

        <div className="font-lato text-[16px] text-secondary text-center leading-relaxed" data-id="element-237">
          <p className="mb-4" data-id="element-238">
            This complete bundle is available at $27 only during the launch
            period. When the test phase ends, the price increases to $47.
          </p>
          <p className="m-0" data-id="element-239">
            There is no reason to wait. Your body has been waiting too long for
            answers.
          </p>
        </div>
      </div>
    </section>;
};